import { Injectable } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { ConfigCacheService } from '@services/api/config-cache.service';

@Injectable({
  providedIn: 'root',
})
export class SalesPresentationService {
  constructor(
    private api: ApiService,
    private configCache: ConfigCacheService
  ) {}

  getProjectGallery(projectId: string = '', folder_name: string = '') {
    return this.api.get(
      `/library/get-office-library/project-extract-files?office_id=${this.api.getOfficeId()}&project_id=${projectId}&project_folder=${folder_name}`
    );
  }
  getSalesPresentationLibraryFolders(projectId: string = '') {
    return this.api.get(`/library/get-office-library/project-extract-sale-files?office_id=${this.api.getOfficeId()}&project_id=${projectId}`);
  }

  /**
   * Called after a file is uploaded into the office library (see the sp-* components' upload
   * handlers) — the session cache (ConfigCacheInterceptor) would otherwise keep serving the
   * pre-upload folder listing for the rest of the session.
   */
  invalidateLibraryCache(): void {
    this.configCache.evict('/library/get-office-library/project-extract-sale-files');
  }
  saveSP(data: any) {
    delete data?._id;
    return this.api.post(`/office/project/sale-representation`, data);
  }

  getSP(project_id: any) {
    return this.api.get(`/office/project/sale-representation?project_id=${project_id}`);
  }
}
